import cx from 'classnames';
import OrderItemsHeaderActions from '../OrderItemsHeaderActions';
import styles from '../OrderItems.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  STATUS,
  GENERIC_USER_ID,
  AFFILIATION_DEALER,
  USER_TYPE_GUEST
} from '@app/constants/commonConstants';
import { InlineLoader } from 'cat-ecommerce-alloy';
import ShareCartButton from '../ShareCartButton';

const OrderItemsHeader = ({
  hasCartError,
  hasItemsInCart,
  noOfItemsInCart
}) => {
  const [t] = useTranslation();
  const { getCurrentOrderStatus } = useSelector(s => s.orders);
  const userId = useSelector(s => s.common?.userId);
  const userAffiliation = useSelector(s => s.common?.userAffiliation);
  const isCSPCustomer = useSelector(s => s.common?.isCSPCustomer);
  const isInstantAccess = useSelector(s => s.common?.isInstantAccess);
  const userType = useSelector(s => s.common?.userType);
  const isLoggedIn = userType !== USER_TYPE_GUEST;
  const isDealerUser = userAffiliation === AFFILIATION_DEALER;
  const isGenericUser = userId === GENERIC_USER_ID;
  const getCurrentOrderLoading =
    (!isGenericUser && getCurrentOrderStatus === STATUS.IDLE) ||
    getCurrentOrderStatus === STATUS.PENDING;
  const ascendingOrderItems = useSelector(
    s => s.orders.byId[s.orders.current]?.ascendingOrderItems || []
  );
  const storeName = useSelector(s => s?.store?.name);
  const isStoreSelected = !!storeName;
  const showShareCart =
    isLoggedIn &&
    isStoreSelected &&
    (isDealerUser || isCSPCustomer || isInstantAccess);
  const showInlineLoader =
    getCurrentOrderLoading && !ascendingOrderItems.length;

  return (
    <div className="d-flex d-print-none flex-column flex-md-row justify-content-md-between w-100">
      {!hasItemsInCart && hasCartError ? null : (
        <div
          className={cx('my-0', 'd-flex', 'align-items-center', {
            'mb-1': hasItemsInCart,
            'mb-0': !hasItemsInCart
          })}
        >
          <span
            className={`align-middle my-0 ${styles['order-items-header__title']}`}
          >
            {t('SHOPCART_ITEMS_IN_CART')}
          </span>
          {showInlineLoader ? (
            <span className="ms-2 my-0 ps-2 d-flex">
              <InlineLoader />
            </span>
          ) : (
            <>
              <span
                className={`align-middle ms-3 my-0 text-sm fw-bold u-color--DarkGray`}
              >
                {noOfItemsInCart}
              </span>
              <span
                className={`align-middle ms-1 my-0 u-color--DarkGray text-sm`}
              >
                {noOfItemsInCart === '1' ? t('2691_ITEM') : t('MO_ITEMS')}
              </span>
            </>
          )}
        </div>
      )}
      {noOfItemsInCart > 0 && (
        <div
          data-testid="order-item-header-button"
          className="d-flex flex-md-row-reverse"
        >
          <OrderItemsHeaderActions />
          {showShareCart && <ShareCartButton />}
        </div>
      )}
    </div>
  );
};

export default OrderItemsHeader;
